module.exports = __webpack_public_path__ + "img/1.84383f8.png";